module.exports = {"body":"<img class=\"big-image\" src=\"/images/alleyesonus_haupt.jpg\" />\n<img class=\"big-image\" src=\"/images/Foto_Manja_Herrmann-0187_klein.jpg\" />\n<img class=\"big-image\" src=\"/images/Foto_Manja_Herrmann-8352_klein.jpg\" />\n<img class=\"big-image\" src=\"/images/Foto_Manja_Herrmann-8386_klein.jpg\" />\n<img class=\"big-image\" src=\"/images/Foto_Manja_Herrmann-8484_klein.jpg\" />"}


//////////////////
// WEBPACK FOOTER
// ./alleyesonus.sidebar.md
// module id = 980
// module chunks = 0